import React, { useCallback, useEffect, useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { meta } from "../../content_option";
import { Container, Row, Col } from "react-bootstrap";
// import faq from "../../assets/videos/faq.mp4";
import faq from "../../assets/videos/Final Product.mp4";
import videoImge from "../../assets/videos/VideographyPackage.webp";
import videoImge2 from "../../assets/videos/REV Reel Comp-new.mp4";
import photograpyImage from "../../assets/videos/photographyimage.jpg";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "./style.css";
import Footer from "../../components/footer";

export const Investment = () => {
  const [cursorStyle, setCursorStyle] = useState({
    opacity: 0,
    top: 0,
    left: 0,
  });

  useEffect(() => {
    // Ensure the public password token never survives a full refresh.
    const clearToken = () => localStorage.removeItem("AdminHeaven");

    // Remove immediately if we landed here via browser refresh.
    const navEntries = window.performance?.getEntriesByType?.("navigation") || [];
    if (navEntries[0]?.type === "reload") {
      clearToken();
    }

    window.addEventListener("beforeunload", clearToken);
    return () => {
      window.removeEventListener("beforeunload", clearToken);
    };
  }, []);

  const handleMouseMove = useCallback((e) => {
    const videoElement = document.querySelector(".video-container");
    if (!videoElement) return;
    const rect = videoElement.getBoundingClientRect();

    if (
      e.clientX >= rect.left &&
      e.clientX <= rect.right &&
      e.clientY >= rect.top &&
      e.clientY <= rect.bottom
    ) {
      setCursorStyle({
        opacity: 1,
        top: e.clientY - 50, // Centering the circle
        left: e.clientX - 50,
      });
    } else {
      setCursorStyle((prev) => ({ ...prev, opacity: 0 }));
    }
  }, []);

  useEffect(() => {
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, [handleMouseMove]);

  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <HelmetProvider>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Investment | {meta.title}</title>
        <meta name="description" content={meta.description} />
      </Helmet>

      <div className="custom-circle" style={cursorStyle}>
        <svg width="150" height="150" viewBox="0 0 150 150" fill="none">
          <circle cx="75" cy="75" r="72" stroke="white" strokeWidth="2" />
        </svg>
        <p className="circle-text">Scroll Down</p>
      </div>

      {/* Video Section */}
      <div className="video-container">
        <video
          src={faq}
          autoPlay
          loop
          muted
          className="vid"
          style={{
            width: "100%",
            objectFit: "cover",
            zIndex: "-1",
            top: 0,
          }}
        ></video>
      </div>
      {/* </div> */}

      {/* <div>
                <video
                    src={faq}
                    autoPlay
                    loop
                    muted
                    className="vid"
                    style={{
                        width: "100%",
                        objectFit: "cover",
                        zIndex: "-1",
                        top: 0,
                    }}
                ></video>
            </div> */}
      <Container style={{ marginTop: "70px", maxWidth: "1480px" }}>
        <Row
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "30px",
          }}
          className="for-space-only"
        >
          <h2 className="faq">INVESTMENT</h2>
        </Row>
        {/* <div className="test-container "style={{marginBottom:"70px" }} >
                    <p>
                        At Made In Heaven, we believe in delivering exceptional, tailored service that brings your wedding vision to life. Each wedding is unique, and we start by meeting with our couples before discussing packages to understand their style, story, and dreams. This helps us create a bespoke approach, ensuring we capture your day in a way that authentically reflects you.
                        Three months before your wedding, we'll meet again to review each detail and ensure our vision aligns with your dream day. By then, we've developed a deep understanding of what matters most to you, so you can relax and trust that we'll capture every meaningful moment exactly as you imagine.
                        Let us be part of your journey, capturing every heartfelt moment with artistry and care.
                    </p>
                </div> */}
{/* Added 'align-items-end' to push shorter columns to the bottom */}
<Row className="align-items-end">
  
  {/* --- LEFT COLUMN (Shorter) --- */}
  <Col xs={12} md={4} className="image-container mb-4 mb-md-0">
    <Link to="/videography-package">
      <img
        src={videoImge}
        alt="Videography Package"
        className="highlight-on-hover"
        style={{
          display: "block",
          width: "100%",
          height: "600px", // Shorter height
          objectFit: "cover",
          border: "5px solid #d3d3d3",
          borderRadius: "60px",
        }}
      />
    </Link>
    <p
      style={{
        fontSize: "1.2rem",
        fontWeight: "600",
        color: "#333",
        marginTop: "15px",
        textAlign: "center",
      }}
    >
      Videography Package
    </p>
  </Col>

  {/* --- MIDDLE COLUMN (Taller) --- */}
  <Col xs={12} md={4} className="image-container mb-4 mb-md-0">
    <Link to="/photo-and-videopackage">
      <video
        autoPlay
        loop
        muted
        src={videoImge2}
        alt="Photography and Videography Package"
        className="highlight-on-hover"
        style={{
          display: "block",
          width: "100%",
          height: "750px", // Taller height
          objectFit: "cover",
          border: "5px solid #d3d3d3",
          borderRadius: "60px",
        }}
      ></video>
    </Link>
    <p
      style={{
        fontSize: "1.2rem",
        fontWeight: "600",
        color: "#333",
        marginTop: "15px",
        textAlign: "center",
      }}
    >
      Photography and Videography Package
    </p>
  </Col>

  {/* --- RIGHT COLUMN (Shorter) --- */}
  <Col xs={12} md={4} className="image-container mb-4 mb-md-0">
    <Link to="/photography-package">
      <img
        src={photograpyImage}
        alt="Photography Package"
        className="highlight-on-hover"
        style={{
          display: "block",
          width: "100%",
          height: "600px", // Shorter height
          objectFit: "cover",
          border: "5px solid #d3d3d3",
          borderRadius: "60px",
        }}
      />
    </Link>
    <p
      style={{
        fontSize: "1.2rem",
        fontWeight: "600",
        color: "#333",
        marginTop: "15px",
        textAlign: "center",
      }}
    >
      Photography Package
    </p>
  </Col>
</Row>
      </Container>

      <Footer />
    </HelmetProvider>
  );
};

export default Investment;
